import React, { SVGProps } from 'react'

/** Feature-local copy glyph for the reveal panel's copy actions (matches the design prototype). */
const SvgCopy = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden="true"
    {...props}
  >
    <rect
      x={5.5}
      y={5.5}
      width={8}
      height={8}
      rx={1.5}
      stroke={props.stroke || 'currentColor'}
      strokeWidth={1.3}
    />
    <path
      stroke={props.stroke || 'currentColor'}
      strokeWidth={1.3}
      strokeLinecap="round"
      d="M3.4 10.4A1.5 1.5 0 0 1 2.5 9V3.5A1.5 1.5 0 0 1 4 2h5.5a1.5 1.5 0 0 1 1.4.9"
    />
  </svg>
)
export default SvgCopy
